import React from 'react';

import AddSightingForm from '../Forms/AddSighting';

const AddSighting = () => {

  return (
    <>
      <h3 className="modal__header">Add a Koala Sighting</h3>
      
      <AddSightingForm />
    </>
  );

}

export default AddSighting;